module.exports = __webpack_public_path__ + "static/media/payment-systems.98822cfe.jpg";